import React from "react";
import PropTypes from "prop-types";
import { Card, Grid } from "@mui/material";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import FormCierreTurno from "../Form/FormCierreTurno";
import TableCame from "../TableCame";

const HeaderSchedule = ({
  children,
  onCloseTurn,
  refreshFlag,
  currentUserRole,
  isAdmin,
  onError,
}) => {
  const handleCloseTurn = async (data) => {
    if (onCloseTurn) {
      await onCloseTurn(data);
    }
  };

  // Función para obtener el mensaje de bienvenida según el rol
  const getWelcomeMessage = () => {
    switch (
      currentUserRole
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    ) {
      case "admin":
        return "Admin";
      case "planeacion":
        return "Planeación";
      case "admin iserra100":
        return "Administrador Principal";
      case "admin iserra100 gerencia":
        return "Gerencia";
      case "admin iserra100 supervisor":
        return "Supervisor";
      default:
        return "Usuario";
    }
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 3, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Cierre de Turno
            </MDTypography>
            {currentUserRole && (
              <MDTypography variant="caption" color="text.secondary">
                Rol: {getWelcomeMessage()}
              </MDTypography>
            )}
          </Grid>
        </Grid>

        <MDBox mt={3} mb={2}>
          <MDTypography variant="h6" fontWeight="medium" color="primary">
            Complete el formulario para cerrar el turno
          </MDTypography>
        </MDBox>

        <FormCierreTurno onSubmit={handleCloseTurn} />

        {/* Línea separadora y tabla solo para administradores */}
        {isAdmin && (
          <MDBox
            mt={4}
            mb={3}
            sx={{
              borderTop: 1,
              borderColor: "divider",
              pt: 3,
            }}
          >
            <MDTypography variant="h6" fontWeight="medium" color="secondary" gutterBottom>
              Historial de Cierres (Vista de Administrador)
            </MDTypography>

            {/* Mostrar qué tipo de administrador está viendo la tabla */}
            <MDTypography variant="caption" color="text.secondary" display="block" mb={2}>
              Accediendo como: <strong>{getWelcomeMessage()}</strong>
            </MDTypography>

            {/* Tabla solo para administradores */}
            <TableCame
              refreshFlag={refreshFlag}
              currentUserRole={currentUserRole}
              isAdmin={isAdmin}
              onError={onError}
            />
          </MDBox>
        )}

        {children && <MDBox mt={4}>{children}</MDBox>}
      </Card>
    </MDBox>
  );
};

HeaderSchedule.defaultProps = {
  children: "",
  onCloseTurn: null,
  refreshFlag: false,
  currentUserRole: "",
  isAdmin: false,
  onError: null,
};

HeaderSchedule.propTypes = {
  children: PropTypes.node,
  onCloseTurn: PropTypes.func,
  refreshFlag: PropTypes.bool,
  currentUserRole: PropTypes.string,
  isAdmin: PropTypes.bool,
  onError: PropTypes.func,
};

export default HeaderSchedule;
